import type { RefObject } from 'react';
import { useDialogFocus } from './useDialogFocus';
import { useDialogKeyboard } from './useDialogKeyboard';

type DrawerA11yOptions = {
  onClose?: () => void;
  triggerRef?: RefObject<HTMLElement | null>;
  blockEscape?: boolean;
};

/**
 * Escape + focus trap for slide-in drawers.
 */
export function useDrawerA11y(
  active: boolean,
  panelRef: RefObject<HTMLElement | null>,
  options: DrawerA11yOptions = {}
): void {
  const { onClose, triggerRef, blockEscape = false } = options;
  useDialogKeyboard(active, { onClose, blockEscape });
  useDialogFocus(active, panelRef, triggerRef);
}
